import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectors as staffSelectors, actions as staffActions } from 'ducks/staff';
import { actions as uiActions } from 'ducks/ui';
import AccountSettings from './AccountSettings';
import { selectors as programAreaSelectors } from 'ducks/programArea';

const mapStateToProps = (state) => ({
  isLoggedIn: staffSelectors.loggedIn(state),
  IsAdministrator: staffSelectors.IsAdministrator(state),
  IsOEAGEnabled: programAreaSelectors.applicationInitData(state)?.featureFlags?.IsOEAGEnabled,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    logout: staffActions.logout,
    toggleDashboardOpen: uiActions.toggleDashboardOpen,
    setIsDashboardDefault: uiActions.setIsDashboardDefault,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
